import partnerLinksView from './partnerLinksListComponent.html';
import './partnerLinksListComponent.css';

export function partnerLinksListComponent() {
	return {
		bindings: {},
		controllerAs: 'vm',
		controller: partnerLinksListComponentCtrl,
		template: partnerLinksView,
	};
}

export class partnerLinksListComponentCtrl {
	constructor($timeout, EventTracker, PartnerLinks) {
		'ngInject';
		this.updateState = this.updateState.bind(this);
		this.$timeout = $timeout;
		this.EventTracker = EventTracker;
		this.PartnerLinks = PartnerLinks;
		this.PartnerLinks.onStateChange(this.updateState);
		this.state = {};
	}

	$onDestroy() {
		this.PartnerLinks.offStateChange(this.updateState);
	}

	updateState(state) {
		this.$timeout(() => {
			this.state = state;
		});
	}

	trackClick(link) {
		this.EventTracker.save('partner_link_click', {
			partner_link_id: link.id,
		});
	}
}
